(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection"] && !window.DesignMode) return;
  try {
    
  class CustomCollectionNavigation extends HTMLElement {
    constructor() {
      super();
      // バインド
      this.handleIntersection = this.handleIntersection.bind(this);
      this.handleDotClick = this.handleDotClick.bind(this);
    }
  
    // custom elementがDOMに追加されたときに呼ばれる
    connectedCallback() {
      if (window.innerWidth > 749) return;
      
      // 要素の取得
      this.slider = this.querySelector('.custom-collection-nav__list--slider');
      this.slides = Array.from(this.querySelectorAll('.custom-collection-nav__list--slider .custom-collection-nav__item'));
      this.dots = Array.from(this.querySelectorAll('.custom-collection-nav__dot'));
  
      if (!this.slider || !this.slides.length || !this.dots.length) {
        console.warn('Required elements not found');
        return;
      }
  
      // IntersectionObserverの設定
      const options = {
        root: this.slider,
        threshold: 0.5
      };
      this.observer = new IntersectionObserver(this.handleIntersection, options);
  
      // 各スライドの監視を開始
      this.slides.forEach(slide => {
        this.observer.observe(slide);
      });
  
      // ドットのクリックイベントを設定
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.handleDotClick(index));
      });
  
      // 最初のドットをアクティブに
      this.updateActiveDot(0);
    }
  
    // スライドが表示領域に入ったときの処理
    handleIntersection(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const slideIndex = this.slides.indexOf(entry.target);
          if (slideIndex !== -1) {
            this.updateActiveDot(slideIndex);
          }
        }
      });
    }
  
    // ドットクリック時の処理
    handleDotClick(index) {
      if (!this.slider || !this.slides[index]) return;
  
      const slide = this.slides[index];
      const slideLeft = slide.offsetLeft - this.slider.offsetLeft;
  
      this.slider.scrollTo({
        left: slideLeft,
        behavior: 'smooth'
      });
    }
  
    // アクティブなドットの更新
    updateActiveDot(activeIndex) {
      this.dots.forEach((dot, index) => {
        if (index === activeIndex) {
          dot.classList.add('custom-collection-nav__dot--active');
        } else {
          dot.classList.remove('custom-collection-nav__dot--active');
        }
      });
    }
  
    // custom elementがDOMから削除されたときに呼ばれる
    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }
  
  // カスタム要素の定義
  customElements.define('custom-collection-navigation', CustomCollectionNavigation);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
